import {
  SiteFeedback,
  SiteFeedbackArgs,
  getSiteFeedback,
} from '../assets/ts/data/site-feedback'
import useServerData from './use-server-data'

function useSiteFeedback(fetchArgs, waitOnParentDependency = false) {
  const {
    data: siteFeedback,
    error: siteFeedbackError,
    fetchData: fetchSiteFeedback,
    isLoading: siteFeedbackIsLoading,
  } = useServerData<SiteFeedback, SiteFeedbackArgs>(
    getSiteFeedback,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchSiteFeedback,
    siteFeedback,
    siteFeedbackError,
    siteFeedbackIsLoading,
  }
}

export default useSiteFeedback
